import type { Response, Request } from "./_type";

import { usePatch } from "~/common/hooks";

export const useRenameConversation = (
  external_user: string,
  session_id: string
) => {
  const url = `/users/${external_user}/${session_id}`;

  return usePatch<Request, Response>(url);
};
